import { SystemPageLayout, Skeleton } from "@components";
import React, { useEffect } from "react";
import Oidc from "oidc-client";
import { routes } from "@routes";
import { setPageTitle } from "@common";
import { useHistory } from "react-router-dom";

function CallbackFromSSOPage(): JSX.Element {
    const content = <Skeleton content="Вход в систему" />;
	const history = useHistory();

	useEffect(() => {
		setPageTitle('Вход в систему');
	}, []);

	new Oidc.UserManager({ response_mode: "query", loadUserInfo: false }).signinRedirectCallback().then(function () {
		let newLocation = sessionStorage.getItem("pageBeforeLogin");
		if (!newLocation || newLocation == routes.ssoCallback.path) {
			newLocation = routes.index.path;
		}
		history.push(newLocation);
	}).catch(function (e) {
		console.error(e);
	});

    return <SystemPageLayout content={content} />
}

export {CallbackFromSSOPage};